import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/common';
import { DashboardLayout } from '../components/layouts';
import { LoginPage, ForgotPasswordPage, ResetPasswordPage } from '../pages/Auth';
import { DashboardPage } from '../pages/Dashboard';
import { ProfilePage } from '../pages/Profile';
import { UserManagementPage } from '../pages/Admin';
import { PlaceListPage, PlaceDetailPage, PlaceCreatePage } from '../pages/Places';
import { KeywordDetailPage } from '../pages/Keywords';

export const router = createBrowserRouter([
  // Public routes
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },

  // Protected routes with Dashboard Layout
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <DashboardLayout />,
        children: [
          {
            path: '/',
            element: <DashboardPage />,
          },
          {
            path: '/profile',
            element: <ProfilePage />,
          },
          {
            path: '/places',
            element: <PlaceListPage />,
          },
          {
            path: '/places/new',
            element: <PlaceCreatePage />,
          },
          {
            path: '/places/:id',
            element: <PlaceDetailPage />,
          },
          {
            path: '/keywords/:id',
            element: <KeywordDetailPage />,
          },
        ],
      },
    ],
  },

  // Admin routes with Dashboard Layout
  {
    element: <ProtectedRoute requireAdmin />,
    children: [
      {
        element: <DashboardLayout />,
        children: [
          {
            path: '/admin/users',
            element: <UserManagementPage />,
          },
        ],
      },
    ],
  },

  // Catch all - redirect to login
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
]);
